import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useVote = () => {
  const { user } = useGetParams();

  const isVisibleRef = useRef(null);
  const [voteState, setVoteState] = useState(null);
  const [voteActivity, setVoteActivity] = useState(null);
  const [currentState, setCurrentState] = useState(null);

  const protocol = window.location.protocol;

  const getVoteInfo = async () => {
    if (!user) {
      return;
    }
    try {
      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { visibility, activity } = data;

      // Определяем видимость титра
      const isVisible = Boolean(Number(visibility));
      if (!isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = false;
      } else if (isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = true;
      }

      // Определяем вкл\выкл интерактив
      const isActivity = Boolean(Number(activity));

      if (!isActivity && isActivity !== voteActivity) {
        setVoteActivity(false);
      } else if (isActivity && isActivity !== voteActivity) {
        setVoteActivity(true);
      }

      // Определяем состояние (S1, S2 ...)
      if (data?.state && getActiveState(data?.state) !== currentState) {
        setCurrentState(getActiveState(data?.state));
      }

      const equal = require('fast-deep-equal');
      if (!equal(voteState, data)) {
        setVoteState(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVoteInfo();
  }, []);

  useInterval(() => {
    getVoteInfo();
  }, 2000);

  return {
    isVisible: isVisibleRef.current,
    voteState,
    voteActivity,
    currentState,
  };
};
